import User from "app/models/user"
import { Action, Types } from "./planningAvailabilities.actions"

export type Params = {
  date: string
  employeeId?: string
  workstationId: string
  functions: string[]
  from: string
  to: string
  sort?: string[]
}

export type PlanningAvailabilityState = {
  errors: {}
  loading: boolean
  params?: Params
  data: User[]
}

const initialState: PlanningAvailabilityState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): PlanningAvailabilityState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        data: [],
        params: action.payload,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data || [],
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.RESET_PARAMS:
      return {
        ...state,
        loading: false,
        params: undefined,
      }

    default:
      return state
  }
}
